// extracted by mini-css-extract-plugin
export default {"page-container":"About_page-container__z6C8z"};